import { Component, EventEmitter, Input, Output } from '@angular/core';

/** Panel de error de una ficha (no existe, sin permiso, fallo de carga): siempre con salida (Reintentar / Volver); nunca pantalla en blanco. */
@Component({
  selector: 'app-error-ficha',
  standalone: true,
  template: `
    <div class="page page--narrow">
      <div class="state-panel state-panel--error" role="alert" data-testid="ficha-error">
        <i class="bi bi-exclamation-octagon-fill state-panel__icon" aria-hidden="true"></i>
        <p class="state-panel__title">No se ha podido mostrar esta pantalla</p>
        <p class="state-panel__text">{{ mensaje }}</p>
        <span class="cluster justify-content-center mt-2">
          @if (reintentable) { <button type="button" class="btn btn-outline-danger" data-testid="ficha-reintentar" (click)="reintentar.emit()"><i class="bi bi-arrow-clockwise" aria-hidden="true"></i>Reintentar</button> }
          <button type="button" class="btn btn-secondary" data-testid="ficha-volver" (click)="volver.emit()">{{ textoVolver }}</button>
        </span>
      </div>
    </div>
  `
})
export class ErrorFichaComponent {
  @Input({ required: true }) mensaje = '';
  @Input() reintentable = true;
  @Input() textoVolver = 'Volver al listado';
  @Output() reintentar = new EventEmitter<void>();
  @Output() volver = new EventEmitter<void>();
}
